var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-page"},[_c('p',{staticClass:"selectcount"},[_vm._v(" 已选择 "),_c('span',[_vm._v(_vm._s(_vm.checkednum))]),_vm._v(" 台云机 ")]),_c('pagination',{attrs:{"currentPage":_vm.currentPage,"pagesize":_vm.pagesize,"total":_vm.total},on:{"handleSizeChange":_vm.handleSizeChange,"handleCurrentChange":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }